import clsx from "clsx";

import { VideoPlayer } from "@atoms/videoPlayer";

import classes from "./styles.module.scss";

import type { IVideoViewerProps } from ".";

export function VideoViewer({ src, title }: IVideoViewerProps) {
  return (
    <div className={clsx(classes.videoViewer)}>
      <div className={clsx(classes.videoViewer__container)}>
        <VideoPlayer
          src={src}
          title={title}
          controls
          autoPlay={false}
          className={clsx(classes.videoViewer__video)}
          playsInline
        />
      </div>
    </div>
  );
}
